import { render, staticRenderFns } from "./KeyboardShortcuts.vue?vue&type=template&id=17460ac4&scoped=true&"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcuts.vue?vue&type=style&index=0&id=17460ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17460ac4",
  null
  
)

export default component.exports